import { useRouteError } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { getApiErrorMessage } from '../services/requestUtils';

export default function RouteErrorPage() {
  const error = useRouteError();
  const message = getApiErrorMessage(error) || error?.message || 'Something went wrong.';

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', mt: 10, px: 2, textAlign: 'center' }}>
      <Typography variant="h5" component="h1" gutterBottom>
        {message}
      </Typography>
      {getApiErrorMessage(error) && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Check that the API is running and reachable from this machine.
        </Typography>
      )}
      <Button variant="contained" onClick={() => window.location.reload()}>
        Retry
      </Button>
    </Box>
  );
}
